// confirm-modal.component.ts
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-confirm-modal',
    template: `
        <div
            class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]"
        >
            <div class="relative bg-white p-6 rounded-2xl shadow-lg w-[300px]">
                <button
                    class="absolute top-3 left-3 text-[#122456] hover:text-gray-300"
                    (click)="cancel()"
                >
                    <img
                        src="assets/images/ezty/icon-close.svg"
                        alt="close"
                        class="w-5 h-5"
                    />
                </button>
                <div class="flex flex-col justify-center items-center">
                    <img
                        src="assets/images/ezty/warning.svg"
                        class="w-20 h-20"
                        alt=""
                    />
                    <p class="mb-6 mt-2 text-[#122456] text-center">
                        {{ message }}
                    </p>
                </div>
                <div class="flex justify-center items-center gap-3">
                    <button
                        class="px-4 py-2 rounded-lg bg-white border border-gray-400 cursor-pointer text-gray-400"
                        (click)="cancel()"
                    >
                        Cancel
                    </button>
                    <button
                        class="px-4 py-2 rounded-lg bg-[#0F75BD] text-white cursor-pointer"
                        (click)="confirm()"
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    `,
})
export class ConfirmModalComponent {
    @Input() message: string = 'Apakah Anda yakin?';
    private result$ = new Subject<boolean>();

    confirm() {
        this.result$.next(true);
        this.result$.complete();
    }

    cancel() {
        this.result$.next(false);
        this.result$.complete();
    }

    getResult() {
        return this.result$.asObservable();
    }
}
